/**
 * Shared dimensions for the document files bar so the values used across
 * dragAndDrop.tsx (inline styles) stay in sync instead of drifting apart.
 *
 * Note: `.dragAndDropBase` in DragAndDrop.css also caps at FILE_BAR_HEIGHT, but
 * its height is kept in CSS because it is overridden to 100% inside
 * `.LightGreyCard` — an inline style would win over that context override.
 * Keep that rule's 50px in sync with FILE_BAR_HEIGHT.
 */

/** Height (and max-height cap) of the files bar, in px. */
export const FILE_BAR_HEIGHT = 50;

/** Height of the inner rows and the Continue button inside the files bar, in px. */
export const FILE_BAR_ROW_HEIGHT = 33;
